export default __webpack_public_path__ + "static/media/githubbutton.246c6adc.webp";